import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { ToTarget } from '@reverbdotcom/commons/src/link_parser';

interface IProps {
  href: ToTarget;
}

export default function PriceGuideToolBailCard({ href }: IProps) {
  return (

    <CoreLink target="_blank" to={href} className="price-guide-tool-bail-card">
      <span className="price-guide-tool-bail-card__text">
        {I18n.t('discovery.priceGuideTool.index.bailCard.text')}
      </span>
      <div className="price-guide-tool-bail-card__link">
        {I18n.t('discovery.priceGuideTool.index.bailCard.linkText')}
      </div>
    </CoreLink>
  );
}
